import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { formatCurrency, formatDate } from '@/lib/utils';
import type { PayoutStatus } from '@trinco/shared';

interface Payout {
  id: string;
  periodStart: string;
  periodEnd: string;
  totalRevenue: number;
  commissionAmount: number;
  tierReached: string | null;
  status: PayoutStatus;
}

const STATUS_STYLES: Record<PayoutStatus, { variant: 'default' | 'secondary' | 'destructive'; label: string }> = {
  pending: { variant: 'secondary', label: 'Pending' },
  approved: { variant: 'default', label: 'Approved' },
  paid: { variant: 'default', label: 'Paid' },
  disputed: { variant: 'destructive', label: 'Disputed' },
};

export function PayoutTable() {
  // Placeholder - will be wired to trpc.commission.payoutHistory
  const payouts: Payout[] = [];

  if (payouts.length === 0) {
    return (
      <div className="py-8 text-center text-sm text-muted-foreground">
        No payout history yet.
      </div>
    );
  }

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Period</TableHead>
          <TableHead className="text-right">Revenue</TableHead>
          <TableHead className="text-right">Commission</TableHead>
          <TableHead>Tier</TableHead>
          <TableHead>Status</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {payouts.map((payout) => {
          const style = STATUS_STYLES[payout.status];
          return (
            <TableRow key={payout.id}>
              <TableCell>
                {formatDate(payout.periodStart)} - {formatDate(payout.periodEnd)}
              </TableCell>
              <TableCell className="text-right">
                {formatCurrency(payout.totalRevenue, 'CAD')}
              </TableCell>
              <TableCell className="text-right font-medium">
                {formatCurrency(payout.commissionAmount, 'CAD')}
              </TableCell>
              <TableCell>{payout.tierReached ?? '-'}</TableCell>
              <TableCell>
                <Badge variant={style.variant}>{style.label}</Badge>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
